import {
  getAll,
  getPage,
  getDetail,
  deleteObj,
  getMyBusinessNotePage,
  modifyPubInfo,
} from '@/api/combovehicleinfoserv'

export default {
  state: {
    state_ComboVehicleInfo_GetAllResult: null,
    state_ComboVehicleInfo_GetPageResult: null,
    state_ComboVehicleInfo_GetDetailResult: null,
    state_ComboVehicleInfo_DeleteObjResult: null,
    state_ComboVehicleInfo_GetMyBusinessNotePageResult: null,
    state_ComboVehicleInfo_ModifyPubInfoResult: null,
  },
  mutations: {
    SET_COMBOVEHICLEINFO_GETALL_RESULT: (state, rst) => {
      state.state_ComboVehicleInfo_GetAllResult = rst;
    },
    SET_COMBOVEHICLEINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_ComboVehicleInfo_GetPageResult = rst;
    },
    SET_COMBOVEHICLEINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_ComboVehicleInfo_GetDetailResult = rst;
    },
    SET_COMBOVEHICLEINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_ComboVehicleInfo_DeleteObjResult = rst;
    },
    SET_COMBOVEHICLEINFO_GETMYBUSINESSNOTEPAGE_RESULT: (state, rst) => {
      state.state_ComboVehicleInfo_GetMyBusinessNotePageResult = rst;
    },
    SET_COMBOVEHICLEINFO_MODIFYPUBINFO_RESULT: (state, rst) => {
      state.state_ComboVehicleInfo_ModifyPubInfoResult = rst;
    },
  },
  actions: {
    ComboVehicleInfoServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_COMBOVEHICLEINFO_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_COMBOVEHICLEINFO_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ComboVehicleInfoServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_COMBOVEHICLEINFO_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_COMBOVEHICLEINFO_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ComboVehicleInfoServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_COMBOVEHICLEINFO_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_COMBOVEHICLEINFO_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ComboVehicleInfoServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_COMBOVEHICLEINFO_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_COMBOVEHICLEINFO_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ComboVehicleInfoServ_GetMyBusinessNotePage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyBusinessNotePage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_COMBOVEHICLEINFO_GETMYBUSINESSNOTEPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_COMBOVEHICLEINFO_GETMYBUSINESSNOTEPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ComboVehicleInfoServ_ModifyPubInfo({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyPubInfo(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_COMBOVEHICLEINFO_MODIFYPUBINFO_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_COMBOVEHICLEINFO_MODIFYPUBINFO_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_ComboVehicleInfo_GetAllResult: state => {
      return state.state_ComboVehicleInfo_GetAllResult;
    },
    get_ComboVehicleInfo_GetPageResult: state => {
      return state.state_ComboVehicleInfo_GetPageResult;
    },
    get_ComboVehicleInfo_GetDetailResult: state => {
      return state.state_ComboVehicleInfo_GetDetailResult;
    },
    get_ComboVehicleInfo_DeleteObjResult: state => {
      return state.state_ComboVehicleInfo_DeleteObjResult;
    },
    get_ComboVehicleInfo_GetMyBusinessNotePageResult: state => {
      return state.state_ComboVehicleInfo_GetMyBusinessNotePageResult;
    },
    get_ComboVehicleInfo_ModifyPubInfoResult: state => {
      return state.state_ComboVehicleInfo_ModifyPubInfoResult;
    },
  }
}